import Intro from './Intro';
import AnimatedTitle from './AnimatedTitle';

export { AnimatedTitle };
export default Intro;
